import { useEffect, useState, useCallback } from 'react';
import { Box } from 'theme-ui';

export function StoreLocator({
  selectedVariant,
  locallyInjected,
  setLocallyInjected,
}) {
  const id = selectedVariant?.id;
  const upc = selectedVariant?.barcode;
  const [loaded, setLoaded] = useState(false);

  const reloadLocallyOnVariantChange = useCallback(() => {
    try {
      if (!id || typeof window.lcly_reload_0 !== 'function') return;
      window.lcly_reload_0({ upc: upc || '' });
    } catch (error) {
      console.error(error.message);
    }
  }, [id, locallyInjected, upc]);

  useEffect(() => {
    const t = document.getElementById('lcly-script-0');
    t && t.parentNode.removeChild(t);
    setLoaded(true);
    return () => {
      setLoaded(false);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && loaded && !locallyInjected) {
      const lclyConfig = {
        company_name: 'Br\u00fcMate',
        button_text: ':heart:',
        button_id: 'HTML',
        company_id: '156418',
        css: '6',
        upc: upc || '',
        n_related_styles: '3',
        show_location_prompt: '1',
        lang: 'en-us',
        show_dealers: '1',
        n_dealers: '3',
        show_location_switcher: '1',
      };
      const lclyQuery = Object.keys(lclyConfig)
        .reduce((a, k) => {
          a.push(
            `${encodeURIComponent(k)}=${encodeURIComponent(lclyConfig[k])}`
          );
          return a;
        }, [])
        .join('&');
      const lclyEndpoint = `https://brumate.locally.com/stores/map.js?${lclyQuery}&v=${Date.now()}`;
      const js = window.document.createElement('script');
      js.src = lclyEndpoint;
      js.type = 'text/javascript';
      js.fetchPriority = 'high';
      js.id = 'lcly-script-0';
      document.head.appendChild(js);
      setLocallyInjected(true);
    }
    return () => {
      const t = document.getElementById('lcly-script-0');
      t && t.parentNode.removeChild(t);
      setLocallyInjected(false);
    };
  }, [loaded, id]);

  useEffect(() => {
    if (locallyInjected) {
      reloadLocallyOnVariantChange();
    }
  }, [loaded, id, locallyInjected]);

  return (
    <Box data-comp={StoreLocator.displayName}>
      <div
        id="lcly-button-0"
        className="lcly-pl-widget-parent"
        data-switchlive="true"
        data-switchlive-impression="true"
        data-switchlive-impression-id-pl="1"
      >
        <a
          id="lcly-link-0"
          data-switchlive="true"
          data-switchlive-mode="auto"
          data-switchlive-id-pl="6"
          href="https://join.locally.com/for-brands"
          target="_blank"
          rel="noreferrer"
        >
          Product Locator by Locally
        </a>
      </div>
    </Box>
  );
}

StoreLocator.displayName = 'StoreLocator';
